import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-71034a84")

_pushScopeId("data-v-71034a84")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Cart")
const _hoisted_2 = {
  key: 0,
  class: "catalog-container"
}
const _hoisted_3 = { class: "scroll" }
const _hoisted_4 = {
  key: 1,
  class: "text-align-center"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "searchbar-not-found text-align-center" }, [
  /*#__PURE__*/_createVNode("h4", null, "Nothing Found")
], -1)
const _hoisted_6 = {
  key: 1,
  class: "text-align-center"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Coming Soon ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" The online warehouse is coming this April. Thank you for your patience. ")
const _hoisted_9 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("div", { class: "item-content item-input item-input-outline" }, [
    /*#__PURE__*/_createVNode("div", { class: "item-inner" }, [
      /*#__PURE__*/_createVNode("div", { class: "item-title item-label" }, "Builder ID"),
      /*#__PURE__*/_createVNode("div", { class: "item-input-wrap" }, [
        /*#__PURE__*/_createVNode("input", {
          id: "builder-id",
          type: "text",
          placeholder: "Enter builder ID",
          required: "",
          validate: ""
        })
      ])
    ])
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Cart")
const _hoisted_11 = { class: "sheet-modal-swipe-step" }
const _hoisted_12 = { class: "display-flex padding justify-content-space-between align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { style: {"font-size":"18px"} }, [
  /*#__PURE__*/_createVNode("b", null, "Total:")
], -1)
const _hoisted_14 = { style: {"font-size":"22px"} }
const _hoisted_15 = { class: "item-content item-input item-input-outline" }
const _hoisted_16 = { class: "item-inner" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "item-title item-label" }, "Builder ID", -1)
const _hoisted_18 = { class: "item-input-wrap" }
const _hoisted_19 = { class: "padding-horizontal padding-bottom" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Checkout")
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "margin-top text-align-center" }, " Swipe up for more details ", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Your order:")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_button = _resolveComponent("f7-button")
  const _component_f7_navbar = _resolveComponent("f7-navbar")
  const _component_f7_searchbar = _resolveComponent("f7-searchbar")
  const _component_f7_list_item = _resolveComponent("f7-list-item")
  const _component_f7_list = _resolveComponent("f7-list")
  const _component_store_list_item = _resolveComponent("store-list-item")
  const _component_f7_block_title = _resolveComponent("f7-block-title")
  const _component_f7_block = _resolveComponent("f7-block")
  const _component_bill_of_materials = _resolveComponent("bill-of-materials")
  const _component_f7_panel = _resolveComponent("f7-panel")
  const _component_f7_sheet = _resolveComponent("f7-sheet")
  const _component_f7_page = _resolveComponent("f7-page")

  return (_openBlock(), _createBlock(_component_f7_page, {
    id: "store",
    name: "store"
  }, {
    default: _withId(() => [
      _createVNode(_component_f7_navbar, { title: "Online Warehouse" }, {
        left: _withId(() => [
          _createVNode(_component_f7_link, {
            class: "mobile-only",
            "icon-only": "",
            "icon-f7": "menu",
            "icon-size": "32",
            "panel-open": "left"
          })
        ]),
        right: _withId(() => [
          _createVNode(_component_f7_button, {
            class: "store-panel-open mobile-only",
            "sheet-open": ".cart-sheet",
            "icon-f7": "cart"
          }, {
            default: _withId(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      true
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode(_component_f7_searchbar, {
              placeholder: "Search by name or ID",
              "clear-button": false,
              "disable-button-text": "Clear",
              "search-container": ".catalog-list"
            }),
            _createVNode("div", _hoisted_3, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_f7_list, {
                    key: 0,
                    "no-hairlines": "",
                    class: "skeleton-text skeleton-effect-wave no-margin",
                    style: {"flex":"1"}
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_f7_list_item, {
                        title: "Title and beans",
                        footer: "Footer"
                      }),
                      _createVNode(_component_f7_list_item, {
                        title: "Title and even mOrE bEans",
                        footer: "Foooooooooooter"
                      }),
                      _createVNode(_component_f7_list_item, {
                        title: "Title and more beans",
                        footer: "Footer"
                      }),
                      _createVNode(_component_f7_list_item, {
                        title: "Title and no beans",
                        footer: "Footooer"
                      })
                    ]),
                    _: 1
                  }))
                : (_ctx.items.length == 0)
                  ? (_openBlock(), _createBlock("h4", _hoisted_4, " Unable to load store. "))
                  : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_f7_list, {
                "media-list": "",
                class: "catalog-list searchbar-found no-margin no-hairline-top"
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                    return (_openBlock(), _createBlock(_component_store_list_item, {
                      key: item.number,
                      item: item
                    }, null, 8, ["item"]))
                  }), 128))
                ]),
                _: 1
              }, 512), [
                [_vShow, !_ctx.loading]
              ]),
              _hoisted_5
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode(_component_f7_block_title, null, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_f7_block, null, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])),
      _createVNode(_component_f7_panel, {
        class: "store-panel",
        right: "",
        "container-el": "#store",
        "visible-breakpoint": 1200
      }, {
        default: _withId(() => [
          (_ctx.appState.admin)
            ? (_openBlock(), _createBlock(_component_f7_list, {
                key: 0,
                class: "no-margin no-padding"
              }, {
                default: _withId(() => [
                  _hoisted_9
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_f7_block_title, null, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_bill_of_materials, {
            items: _ctx.cart,
            style: {"z-index":"0"}
          }, null, 8, ["items"]),
          _createVNode(_component_f7_button, {
            class: "place-order",
            fill: "",
            color: _ctx.cart.length == 0 ? 'gray' : 'green',
            text: "Checkout",
            disabled: _ctx.cart.length == 0,
            onClick: _ctx.checkout,
            preloader: "true",
            loading: _ctx.isCheckoutLoading
          }, null, 8, ["color", "disabled", "onClick", "loading"])
        ]),
        _: 1
      }),
      _createVNode(_component_f7_sheet, {
        class: "cart-sheet",
        style: {"height":"auto"},
        "swipe-to-close": "",
        "swipe-to-step": "",
        backdrop: ""
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("div", _hoisted_14, [
                _createVNode("b", null, _toDisplayString(_ctx.total), 1)
              ])
            ]),
            (_ctx.appState.admin)
              ? (_openBlock(), _createBlock(_component_f7_list, {
                  key: 0,
                  class: "no-margin no-padding no-hairlines no-hairlines-bottom"
                }, {
                  default: _withId(() => [
                    _createVNode("li", null, [
                      _createVNode("div", _hoisted_15, [
                        _createVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createVNode("div", _hoisted_18, [
                            _createVNode("input", {
                              id: "builder-id-mobile",
                              type: "text",
                              placeholder: "Enter builder ID",
                              required: "",
                              validate: "",
                              value: _ctx.builderID
                            }, null, 8, ["value"])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_19, [
              _createVNode(_component_f7_button, {
                "sheet-close": "",
                onClick: _ctx.checkout,
                large: "",
                fill: "",
                color: _ctx.cart.length == 0 ? 'gray' : 'green',
                disabled: _ctx.cart.length == 0,
                preloader: "true",
                loading: _ctx.isCheckoutLoading
              }, {
                default: _withId(() => [
                  _hoisted_20
                ]),
                _: 1
              }, 8, ["onClick", "color", "disabled", "loading"]),
              _hoisted_21
            ])
          ]),
          _createVNode(_component_f7_block_title, {
            medium: "",
            class: "margin-top"
          }, {
            default: _withId(() => [
              _hoisted_22
            ]),
            _: 1
          }),
          _createVNode(_component_bill_of_materials, {
            items: _ctx.cart,
            hideSubtotal: "",
            readonly: ""
          }, null, 8, ["items"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})